import { SpyneTrait } from 'spyne';

export class DeckControlsViewTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'deckControls$';
    super(context, traitPrefix);
  }

  // The icon swap is CSS on main#app[data-fullscreen]; this keeps the button's
  // accessible state in step.
  static deckControls$OnFullscreenChange(e) {
    const isFullscreen = e.payload?.isFullscreen === true;
    const button = this.props.el$('.deck-control--fullscreen').el;

    button.setAttribute('aria-pressed', String(isFullscreen));
    button.setAttribute(
      'aria-label',
      isFullscreen ? 'Exit full screen' : 'Enter full screen',
    );
    // The click leaves focus on the button; Space and Enter would then toggle
    // fullscreen instead of stepping the slideshow.
    button.blur();
  }
}
